import request from "superagent";

const URL = 'https://f2-birdzai-be.herokuapp.com';

export async function signup(email, password) {
    const data = await request
    .post(`${URL}/auth/signup`)
    .send({
        email: email,
        password: password,
    })

    return data.body.token;
}

export async function login(email, password) {
    const data = await request
    .post(`${URL}/auth/signin`)
    .send({
        email: email,
        password: password,
    })

    return data.body.token;
}

export const getBirds = async (token) => {
      //return console.log('no birds');
        return await request
        .get(`${URL}/api/birds`)
        .set('Authorization', token);

}

export async function getWatchlist(token) {
    return await request
        .get(`${URL}/api/watchlist`)
        .set('Authorization', token)
}

export async function addWatchlist(watchlist, token) {
    const data = await request.post(`${URL}/api/watchlist`)
        .set('Authorization', token)
        .send({
            common_name: watchlist.common_name,
            observation_date: watchlist.observation_date,
            latitude: watchlist.latitude,
            longitude: watchlist.longitude,
            subId: watchlist.subId,
            locName: watchlist.locName
        })

    return data.body;
}
export async function deleteFromWatchlist(id, token){
    const data =await request.delete(`${URL}/api/watchlist/${id}`)
    .set('Authorization', token)

    return data;
}

